import { render, staticRenderFns } from "./RecFlow.vue?vue&type=template&id=ba89da4a&scoped=true&"
import script from "./RecFlow.vue?vue&type=script&lang=js&"
export * from "./RecFlow.vue?vue&type=script&lang=js&"
import style0 from "./RecFlow.vue?vue&type=style&index=0&id=ba89da4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba89da4a",
  null
  
)

export default component.exports